import { Tooltip } from 'antd';
import React, { FC } from 'react';
import styled, { css } from 'styled-components';
import { Channel } from 'api/notifications';
import { Checkbox } from 'components/atoms/checkbox';
import { ClassNameOnlyProps } from 'components/ozone-component';
import { BodyShort01 } from 'components/styles';
import { useTranslation } from 'hooks/use-translation';

export const ChannelStyles = css`
  display: flex;
  flex: 1 0 30%;
  margin-left: auto;
  margin: 0 var(--layout-01);
`;

export const CellStyles = css`
  display: flex !important;
  justify-content: center;
  flex: 1 0 0;
`;

export const Item = styled.div`
  display: flex;
  flex: 1 0 100%;
  padding: var(--layout-01) var(--layout-01) calc(var(--layout-01) - 1px);
  justify-content: space-between;
  ${BodyShort01};
`;

export const Title = styled.div`
  flex: 1 0 55%;
`;

export const ChannelOptions = styled(Checkbox.Group)`
  ${ChannelStyles};
`;

interface ChannelOptionProps extends ClassNameOnlyProps {
  value: Channel;
  disabled: boolean;
  title?: string;
}

const ChannelOptionComponent: FC<ChannelOptionProps> = ({
  value,
  className,
  disabled,
  title,
}) => {
  const defaultTitle = useTranslation('notifications.messages.cannot_edit');

  return disabled ? (
    <Tooltip className={className} title={title ?? defaultTitle}>
      <Checkbox className={className} value={value} disabled />
    </Tooltip>
  ) : (
    <Checkbox className={className} value={value} />
  );
};

export const ChannelOption = styled(ChannelOptionComponent)`
  ${CellStyles};
`;
